// extracted by mini-css-extract-plugin
export default {"tabBtn":"NavigationTabs_tabBtn__5HQ2P","tabBtnText":"NavigationTabs_tabBtnText__sdX2B"};